import React, { useState } from 'react'
import Layout from '../Layout'
import styled, { css } from 'styled-components'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import SVG from 'react-inlinesvg'

//sections

//components
import SEO from '../components/SEO'
import Header from '../components/Header'
import Paragraph from '../components/Paragraph'
import SectionSeparator from '../components/SectionSeparator'
import FormResponse from '../components/FormResponse'
import Input from '../components/Input'
import Loader from '../components/Loader'
import Popup from '../components/Popup'
import Button from '../components/Button'
import chevron from '../assets/svg/chevron.svg'
import Slider from '../components/Slider'

//images
import BgImage from '../assets/images/events/main2.png'
import slide1 from '../assets/images/events/slide1.png'
import BgTextured from '../assets/images/bg3.png'

//sliders
import b1 from '../assets/images/events/bespoke/1.jpg'
import b2 from '../assets/images/events/bespoke/2.jpg'
import b3 from '../assets/images/events/bespoke/3.jpg'
import b4 from '../assets/images/events/bespoke/4.jpg'
import b5 from '../assets/images/events/bespoke/5.jpg'
import b6 from '../assets/images/events/bespoke/6.jpg'
import b7 from '../assets/images/events/bespoke/7.jpg'
import b8 from '../assets/images/events/bespoke/8.jpg'

import cg1 from '../assets/images/events/corporate_gale/1.jpg'
import cg2 from '../assets/images/events/corporate_gale/2.jpg'
import cg3 from '../assets/images/events/corporate_gale/3.jpg'
import cg4 from '../assets/images/events/corporate_gale/4.jpg'
import cg5 from '../assets/images/events/corporate_gale/5.jpg'
import cg6 from '../assets/images/events/corporate_gale/6.jpg'
import cg7 from '../assets/images/events/corporate_gale/7.jpg'

import l1 from '../assets/images/events/launches/1.jpg'
import l2 from '../assets/images/events/launches/2.jpg'
import l3 from '../assets/images/events/launches/3.jpg'
import l4 from '../assets/images/events/launches/4.jpg'
import l5 from '../assets/images/events/launches/5.jpg'
import l6 from '../assets/images/events/launches/6.jpg'
import l7 from '../assets/images/events/launches/7.jpg'

import pc1 from '../assets/images/events/personal_celebrations/1.jpg'
import pc2 from '../assets/images/events/personal_celebrations/2.jpg'
import pc3 from '../assets/images/events/personal_celebrations/3.jpg'
import pc4 from '../assets/images/events/personal_celebrations/4.jpg'
import pc5 from '../assets/images/events/personal_celebrations/5.jpg'
import pc6 from '../assets/images/events/personal_celebrations/6.jpg'
import pc7 from '../assets/images/events/personal_celebrations/7.jpg'

const ContactForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  margin: 0 auto;

  > form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-width: 400px;
    min-height: 200px;
    margin: 0;
    padding: 50px;
    text-align: center;
    transition: opacity 0.6s ease;
    opacity: ${({ loading }) => (loading ? '0.5' : '1')};
    ${({ none }) => none && 'opacity: 0;'}
  }

  textarea {
    display: block;
    width: 100%;
    height: 150px;
    margin: 0 0 15px;
    background: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  > button {
    font-weight: ${({ theme }) => theme.font.bold};
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
  }

  ${({ theme }) => theme.media.l} {
    width: 600px;
  }
`

const InputWrapper = styled.div`
  position: relative;
  z-index: 500;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 20px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  > input {
    width: 100%;
    padding: 5px 40px 5px 0;
    caret-color: transparent;
    text-overflow: ellipsis;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.3s ease;

    &:focus {
      opacity: 1;
    }

    ::placeholder {
      color: white;
    }
  }

  > svg {
    position: absolute;
    top: 10px;
    right: 0;
    display: block;
    width: 15px;
    height: 15px;
    pointer-events: none;
    transform: rotate(180deg);
  }

  > span {
    position: absolute;
    top: 22px;
    right: 0;
    font-size: 12px;
    font-weight: ${({ theme }) => theme.font.bold};
    line-height: 1;
    color: #f64d0a;
  }

  ${({ theme }) => theme.media.l} {
    > svg {
      top: 10px;
      right: 0;
    }
  }
`

const RestaurantSelect = styled.ul`
  z-index: 700;
  list-style: none;
  overflow-y: scroll;
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  width: 100%;
  height: 300px;
  background: rgba(22, 22, 22, 0.88);
  padding: 30px 30px 0 0;

  ${({ visible }) =>
    visible
      ? css`
          opacity: 1;
          pointer-events: auto;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `}

  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;
  }

  ::-webkit-scrollbar {
    width: 12px;
    background-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.primary};
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
  }

  > li {
    position: relative;
    padding: 15px 20px;
    font-weight: ${({ theme }) => theme.font.light};
    color: #747474;
    letter-spacing: 0.03em;
    cursor: pointer;

    :before {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 20px;
      height: 1px;
      background: white;
      opacity: 0.1;
    }

    span {
      font-weight: ${({ theme }) => theme.font.bold};
    }

    :hover {
      background: ${({ theme }) => theme.colors.primary};
      color: #1f2123;
    }
  }

  ${({ theme }) => theme.media.l} {
    height: 250px;
  }
`

const SVGchevron = styled(SVG)`
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`


const Wrapper = styled.section`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  background: #171717;
  background: top left no-repeat;
  background-image: url(${({ background }) => (background) ? background : '' });
  background-size: cover;
  transition: all 0.3s ease;

  h2 {
    margin-top: 50px;
    font-size: 42px;
  }

  ${({ theme }) => theme.media.l} {
    flex-direction: row;
  }
`

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  max-width: ${({ maxWidth }) => (maxWidth) ? maxWidth : '1080px' };
  margin: auto;
  padding: 80px 30px 100px;
  display: ${({ display }) => (display) ? display : '' };
`
const LogoWrapper = styled.div`
  margin-left: -20px;
`

const Content = styled.div`
  padding: 15px;
  width: ${({ width }) => (width) ? width : '100%' };
`

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 30px 100px;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => theme.media.m} {
    padding: 140px 30px 100px;
  }

  ${({ theme }) => theme.media.l} {
    padding: 180px 50px 100px;
  }

  ${({ theme }) => theme.media.xl} {
    padding-top: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding-top: 360px;
  }
`

const BackgroundImage = styled.figure`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: -15%;
  width: 115%;
  height: 100%;
  background: top left no-repeat;
  background-size: cover;
  z-index: 1;

  opacity: 0;

  -webkit-animation-name: fade, heroMoveSlide;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-duration: ${({ totalDuration }) => totalDuration}s;
  
  animation-name: fade, heroMoveSlide;
  animation-iteration-count: infinite;
  animation-duration: ${({ totalDuration }) => totalDuration}s;

  background-image: url(${({ image }) => image});

  -webkit-animation-delay: ${({ delay }) => delay}s;
  
`

const UsEnjoy = styled.div`
  display: block;
  ${({ theme }) => theme.media.l} {
    display: flex;
  }
`

const TerracesPage = (data) => {

  const [formPopup, setFormPopup] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)
  const [focused, setFocused] = useState(false)

  const { handleSubmit, register, errors } = useForm()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const onSubmit = values => {
    const d = new FormData(document.getElementById('events-form'))
    sendRequest(d)

  }

  const sendRequest = values => {
    //console.log(values); return false;
    setLoading(true)
    axios.post('https://www.alto.com.hk/api/eventsEnquiries',values)
      .then( (response) => {
        setLoading(false)
        setSuccess(true)
        console.log(response.data)
      })
      .catch( (error) => {
        setLoading(false)
        setError(true)
        console.log(error.errors)
      })
    /*setLoading(true)
    axios({
      method: 'post',
      url: 'https://snsbackend.herokuapp.com/inquiries',
      data: values,
    })
      .then(function(response) {
        setLoading(false)
        setSuccess(true)
        console.log(response.data)
      })
      .catch(function(error) {
        setLoading(false)
        setError(true)
        console.log(error)
      })*/
  }

  const handleClick = (name, id, item) => {
    setCurrentItem(item)
  }

  const images = [
    slide1, BgImage
  ]

  let imagesCount = 2
  let duration = 5
  let transition = 2

  const t = imagesCount * (duration + transition)

  const p1 = Math.round(transition / t * 100)
  const p2 = Math.round((duration + transition) / t * 100)
  const p3 = Math.round(p2 * 1.6)

  let keyframesMove = `
    0% {opacity: 0;}
    ${p1}% {opacity: 0.5;}
    ${p2}% {opacity: 0.5;}
    ${p3}% {opacity: 0;}
    100% {opacity: 0;}
  `
  let keyframesHeroMove = `
    0% {
      transform: translate3d(0, 0, 0);
    }
    50% {
      transform: translate3d(10%, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  `

  let keyframes = `
    @keyframes fade {
      ${keyframesMove}
    }
    @-webkit-keyframes fade {
      ${keyframesMove}
    }
    @keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
    @-webkit-keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
  `
  const restaurants = data.data.allStrapiRestaurants.edges

  return (
    <Layout>
      <SEO 
        title="Catering Services Hong Kong | S&S Hospitality" 
        canonical="https://www.sandshospitality.com/catering-services/" 
        description='As Hong Kong’s most sought-after caterer, we offer packages to suit any function. Our range of restaurants & bars ensures a unique menu within your budget.' 
        keywords={[
          { seo_keyword: 'catering hong kong' }, 
          { seo_keyword: 'catering service hong kong' },
          { seo_keyword: 'catering services' }
        ]}
      />
      <Wrapper>
        <Container>
            <Header align="left" paddingBottom="30px">Catering Hong Kong</Header>
            <Paragraph white>
              From first appearances to lasting impressions – nobody does it better than S&S Hospitality. 
            </Paragraph>
        </Container>
        {images.map((img, key) =>
          <BackgroundImage key={key}
            style={{
              backgroundImage: `url(${img})`,
              animationDelay: `${(duration + transition) * key}s`
            }}
            totalDuration={t}
          />
        )}
        <style>{keyframes}</style>
      </Wrapper>
      <Wrapper background={BgTextured}>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', marginTop: '50px' }}>About S&S Events</h2>
          <Content width="100%">
            <Paragraph center>
            Hosting and designed by S&S Hospitality, each event has you and your ideas at heart from start to finish. With you, we meticulously build your event keeping in mind the look you want your guests to be amazed by, the décor, music, special effects, menus right up to the show-bags your guests take home!
            </Paragraph>
            <Paragraph center>
            With our extraordinary cuisine and premium selection of specialty wines, we style your event flawlessly until you are beyond satisfied. Our professional Event Specialists ensure that ‘wow’ factor leaving you and your guests spellbound with memories to last a lifetime.
            </Paragraph>
          </Content>
          <Content width="100%">
            <h3 style={{ textAlign: 'center' }}>With us you enjoy:</h3>
            <UsEnjoy>
              <Paragraph style={{ padding: '10px'}}><span style={{ fontWeight: 700 }}>Stress-free Management:</span><br /> When you book with us, you get the peace of mind that comes
                with knowing that the ‘work is ours’ and the ‘fun is yours.’
              </Paragraph>
              <Paragraph style={{ padding: '10px'}}><span style={{ fontWeight: 700 }}>Service-hearted Staff:</span> <br />Our dynamic and professional team makes the whole planning and
                organizing a fun-filled process which you will love!
              </Paragraph>
              <Paragraph style={{ padding: '10px'}}><span style={{ fontWeight: 700 }}>Selections of international cuisine:</span><br /> Our fabulous restaurants custom-design menus to suit
                your particular requirements and bring you a galaxy of mouthwatering choices.
              </Paragraph>
              <Paragraph style={{ padding: '10px'}}><span style={{ fontWeight: 700 }}>Bespoke Décor:</span><br /> We design your event with shapes and forms, colours and textures that
                bring you that precise ‘emotion’ you want your event to express. 
              </Paragraph>
              <Paragraph style={{ padding: '10px'}}><span style={{ fontWeight: 700 }}>Technology-driven:</span><br /> We have access to the best event-automation and presentation
                technology and best-in-class trained staff to make your event a true success
              </Paragraph>
            </UsEnjoy>
          </Content>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>Corporate Meetings – Gala Dinners – Cocktail Receptions</h2>
          <Content>
            <Paragraph center>
            S&S Hospitality remains the premier one-stop-shop for Hong Kong’s leading companies and brands looking for inspiring venues, top-notch catering and cutting-edge quality of service, to give their indoor/outdoor events that world-class sheen.
            </Paragraph>
            <Paragraph center>
            Our team of Event Specialists take each event personally. We work with you to understand your vision, explore your choices and arrive at the optimum solution that you are delighted with.
            </Paragraph>
            <Paragraph center>
            Our Group’s multi-flavoured restaurants assure you of the best quality and presentation of food in Hong Kong. For your choice of fine wines and soft drinks, the options are endless. What is needed is an experienced, guiding hand to help you get the most value for your event dollar.
            </Paragraph>
          </Content>
          <Slider images={[cg1, cg2, cg3, cg4, cg5, cg6, cg7]} />
          <Paragraph center><i>Call us today to discuss your next corporate event and let us unveil the possibilities: events@sandshospitality.com | +852 3906 8807 </i></Paragraph>
          <div style={{ textAlign: 'center' }}><Button onClick={() => setFormPopup(true)} onKeyDown={() => setFormPopup(true)}>Inquire now</Button></div>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>Product Launches & Media Events</h2>
          <Content>
            <Paragraph center>
            Product launches are central to the DNA of the brand and S&S Hospitality – operator of Hong Kong’s most envied signature restaurants, bars and lounges – offers the perfect venues and services to make your company vision come to life.
            </Paragraph>
            <Paragraph center>
            We bring to your event, this wealth of experience, a range of new ideas on how to make the biggest and most lasting impression on your guests. Our ‘bespoke’ service ensures the whole launch carries the flavor of the product/service right into the hearts and minds of your guests. 
            </Paragraph>
            <Paragraph center>
            We help personalize the guests experience and make it fun. So little extras such as adding your logo to the menu or incorporating a ‘wine-tasting’ or ‘pasta making’ spotlight in your main event gives your guests an unforgettable experience to ‘take home’.   
            </Paragraph>
          </Content>
          <Slider images={[l1, l2, l3, l4, l5, l6, l7]} />
          <Paragraph center><i>Enquire today to discover how you can take advantage of this one-stop-shop resource to make your next Media Event a resounding success: events@sandshospitality.com | +852 3906 8807</i></Paragraph>
          <div style={{ textAlign: 'center' }}><Button onClick={() => setFormPopup(true)} onKeyDown={() => setFormPopup(true)}>Inquire now</Button></div>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>PERSONAL CELEBRATIONS</h2>
          <Content>
            <Paragraph center>
            Life’s best moments live on forever as treasures of the heart. We make those jewels shine brightest for you to look back on every single day of your life. 
            </Paragraph>
            <Paragraph center>
            Our team works with you to create the perfect birthday, fun-filled bridal showers and baby showers, memorable graduation ceremonies, sentimental anniversaries, exciting and even experimental bachelor’s night, candle-lit Valentine’s Day celebrations and a range of dazzling ‘thank you’ parties, lunches, dinners and cocktails.   
            </Paragraph>
            <Paragraph center>
            Creating the city’s finest events and parties has made us Hong Kong’s first choice for Personal Celebrations. Be it a surprise cake, or a thoughtful gift, a special item on the menu, live bands or even the appearance of a live portrait artist or a magician – we follow what comes from the heart. Your joy is our success.
            </Paragraph>
          </Content>
          <Slider images={[pc1, pc2, pc3, pc4, pc5, pc6, pc7]} />
          <div style={{ textAlign: 'center' }}><Button onClick={() => setFormPopup(true)} onKeyDown={() => setFormPopup(true)}>Inquire now</Button></div>
        </InnerWrapper>
        <SectionSeparator />
        <InnerWrapper>
          <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>Bespoke Catering Services</h2>
          <Content>
            <Paragraph center>
            Being Hong Kong’s most sought-after specialty caterer, we offer sophisticated catering packages to suit any function. Our growing range of specialty restaurants and exquisite bars ensure you a unique menu along with a selection of craft cocktails and beverages – all within your budget.
            </Paragraph>
            <Paragraph center>
            We also offer a team of experienced catering staff, including waiters, chefs and mixologists, available to make your event the success it deserves to be.  
            </Paragraph>
            <Paragraph center>
            Suitable for all occasions, our bespoke catering team serves:  
            </Paragraph>
            <Paragraph center> 
            <span style={{ fontWeight: 700 }}>~ Junk boat parties ~</span><br />
            <span style={{ fontWeight: 700 }}>~ Office lunches and celebrations ~ </span><br />
            <span style={{ fontWeight: 700 }}>~ Weddings, gala dinners, trade fairs ~</span><br />
          	<span style={{ fontWeight: 700 }}>~ House dinners or private gatherings ~ </span><br />
            <span style={{ fontWeight: 700 }}>~ Weddings, gala dinners, trade fairs ~</span><br />
            <span style={{ fontWeight: 700 }}>~ In-store events ~ </span><br />
            Quality tried and tested, our off-site food and beverage service is exactly the same as you would expect to find in our fine restaurants – no compromises.  
            </Paragraph>
          </Content>
          <Slider images={[b1, b2, b3, b4, b5, b6, b7, b8]} />
          <Paragraph center><i>Enquire about our bespoke catering services today: events@sandshospitality.com | +852 3906 8807 </i></Paragraph>
          <div style={{ textAlign: 'center' }}><Button onClick={() => setFormPopup(true)} onKeyDown={() => setFormPopup(true)}>Inquire now</Button></div>
        </InnerWrapper>
      </Wrapper>

      <Popup
        active={formPopup === true}
        handleClose={() => setFormPopup(false)}
      >
        <h3>Inquiry form</h3>
        <ContactForm none={error || success} loading={loading}>
          <form id="events-form" onSubmit={handleSubmit(onSubmit)}>
            <InputWrapper>
              <input
                name="restaurant"
                placeholder="Choose a restaurant..."
                value={currentItem && currentItem.Name}
                ref={register({
                  required: 'Please chose a restaurant',
                })}
                onFocus={() => setFocused(true)}
                onBlur={() => setTimeout(() => setFocused(false), 100)}
                autoComplete="false"
                required
              />
              <RestaurantSelect visible={focused}>
                {restaurants.map(
                  (item, index) =>
                    item.node.bookingsId && (
                      <li
                        key={item.node.bookingsId}
                        onClick={() =>
                          handleClick(
                            item.node.Name,
                            item.node.bookingsId,
                            item.node
                          )
                        }
                        onKeyDown={() =>
                          handleClick(
                            item.node.Name,
                            item.node.bookingsId,
                            item.node
                          )
                        }
                      >
                        <span>{item.node.Name}</span> / Cuisine :{' '}
                        {item.node.cuisine['Name']} / Adress :{' '}
                        {item.node.Address}
                      </li>
                    )
                )}
              </RestaurantSelect>
              <SVGchevron src={chevron} />
              {errors.restaurant && <span>{errors.restaurant.message}</span>}
            </InputWrapper>
            <Input
              name="name"
              placeholder="Name"
              validation={register({
                required: 'name is required',
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: 'name may contains only letters',
                },
              })}
              errors={errors.name}
              required
            />
            <Input
              name="phone"
              placeholder="Phone"
              validation={register({
                required: 'phone is required',
                pattern: {
                  value: /^[0-9\s]*$/,
                  message: 'invalid phone number',
                },
              })}
              errors={errors.phone}
              required
            />
            <Input
              name="email"
              placeholder="Your email address"
              validation={register({
                required: 'mail is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'invalid email address',
                },
              })}
              errors={errors.email}
              required
            />
            <Input
              name="date"
              placeholder="Event date"
              validation={register({
                required: 'date is required',
                pattern: {
                  value: /^[0-9\s]*$/,
                  message: 'invalid date (please, use format: YYYY-MM-DD)',
                },
              })}
              errors={errors.date}
              required
            />
            <Input
              name="startTime"
              placeholder="Event time (from)"
              validation={register({
                required: 'time (from) is required',
                pattern: {
                  value: /^[0-9\s]*$/,
                  message: 'invalid time',
                },
              })}
              errors={errors.startTime}
            />
            <Input
              name="endTime"
              placeholder="Event time (to)"
              validation={register({
                required: 'time (to) is required',
                pattern: {
                  value: /^[0-9\s]*$/,
                  message: 'invalid time',
                },
              })}
              errors={errors.endTime}
            />
            <Input
              name="guests"
              placeholder="No of guests"
              validation={register({
                required: 'number of guests is required',
                pattern: {
                  value: /^[0-9\s]*$/,
                  message: 'invalid number',
                },
              })}
              errors={errors.guests}
            />
            <textarea
              name="remarks"
              placeholder="Remarks"
              ref={register({})}
            ></textarea>
            <Button type="submit">Submit</Button>
          </form>
          <Loader active={formPopup && loading} />
          <FormResponse
            active={formPopup && (error || success)}
            success={success}
            successMsg="You've inqury has been sent. We'll get back to you for more details and confirmation."
          />
        </ContactForm>
      </Popup>

    </Layout>
  )
}

export default TerracesPage

export const pageQuery = graphql`
  query EventsQuery {
    allStrapiRestaurants(sort: { fields: [Order], order: ASC }) {
      edges {
        node {
          id
          Order
          slug
          published
          Name
          Address
          bookingsId
          cuisine {
            Name
          }
          type {
            Name
          }
          location {
            Name
          }
        }
      }
    }
  }
`